import React from "react";
import Navbar from "./navbar";
import Footer from "./footer-v2";
import ChatPopup from "../ChatPopup";

export const Layout = (props) => {

    return (
        <React.Fragment>
            <div>
                <Navbar />

                <div>
                    {props.children}
                </div>
                <ChatPopup />
                <Footer />
            </div>
        </React.Fragment>
    )
}